import { Component } from '@angular/core';
import { IVersion } from '@devinforius/i-essentials';

@Component({
  selector: 'app-assistance',
  standalone: false,
  templateUrl: './assistance.component.html',
  styleUrl: './assistance.component.scss'
})
export class AssistanceComponent {
  public versions: IVersion[] = [
    {number: '1.0.0', pdfURL: '', shortDescription: '', latest: true}
  ];
}
